import React from 'react'

import { withRouter } from 'react-router-dom'

import { Chart } from 'primereact/chart';
import { DataView, DataViewLayoutOptions } from 'primereact/dataview';
import { Badge } from 'primereact/badge';
import { Button } from 'primereact/button'
import { Calendar } from 'primereact/calendar'
import { Toast } from 'primereact/toast';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

import NavBar from '../../componentes/Navbar'

import GraficoAtividadeService from '../../app/service/GraficoAtividadeService'
import FinanceiroService from '../../app/service/FinanceiroService'
import UsuarioService from '../../app/service/UsuarioService'
import { AuthContext } from '../../main/ProvedorAutenticacao'

import './grafico.css'
import '../processo/processo.css'

class GraficoAtividades extends React.Component {
  constructor(props) {
    super(props);

    this.graficoAtividadeService = new GraficoAtividadeService();
    this.financeiroService = new FinanceiroService();
    this.usuarioService = new UsuarioService();

    this.state = {
      meses: [],
      graficoAtividades: [],
      graficoAtividadesData: null,
      graficoAtividadesDataLimite: [],
      graficoAtividadesConcluido: [],
      graficoAtividadesDataLImiteConcluidoData: null,
      graficoStatus: [],
      graficoStatusData: null,
      graficoSituacaoEmpresa: [],
      graficoSituacaoEmpresaData: null,
      detail: '',
      openSpinner: false,
      //Grupos de Trabalho
      graficoAtividadeGrupo: [],
      graficoAtividadeGrupoPie: null,
      //Fases
      graficoAtividadeFases: [],
      graficoAtividadeFasesPie: null,
      layout: 'list',
      //Consulta
      dataInicialGeral: '',
      dataFinalGeral: '',
      dataInicialUsuario: '',
      dataFinalUsuario: '',
      paramGraficoUsuario: '',
      modalLoad: '',
    };

    this.kleiton = {
      maintainAspectRatio: false,
      aspectRatio: .8,
      plugins: {
          legend: {
              labels: {
                  color: '#495057'
              }
          }
      },
    }

    this.options = this.getLightTheme();
  }

  listarMeses = async () => {
    await this.financeiroService.listarMeses()
      .then(response => {
        this.setState({meses: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Financeiro - Meses', detail:`${this.state.detail}`, life: 4000});
      })
  }

  ativdadesStatus = async (dataInicial, dataFinal) => {
    const usuarioLogado = this.context.usuarioAutenticado

    await this.graficoAtividadeService.graficoAtividadesStatus(usuarioLogado.empresa.codigo, dataInicial, dataFinal)
      .then(response => {
        this.setState({graficoStatus: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Graficos Atividades', detail:`${this.state.detail}`, life: 4000});
      });

      let status = [];
      for(let i = 0; i < this.state.graficoStatus.length; i++) {
        status.push(this.state.graficoStatus[i].status);
      }

      let totais = [];
      for(let i = 0; i < this.state.graficoStatus.length; i++) {
        totais.push(this.state.graficoStatus[i].total);
      }

      await this.setState({graficoStatusData: {
        labels: status,
        datasets: [
          {
            data: totais,
            backgroundColor: [
              "#42A5F5",
              "#66BB6A",
              "#FFA726",
              "#BBCCCC",
              "#FF0000"
            ],
          }
        ]
      }});
  }

  atividadesDataLimiteConcluidas = async () => {
    const usuarioLogado = this.context.usuarioAutenticado

    await this.graficoAtividadeService.graficoDataLimite(usuarioLogado.empresa.codigo, '2022-01-01', '2022-12-31')
      .then(response => {
        this.setState({graficoAtividadesDataLimite: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Graficos Atividades', detail:`${this.state.detail}`, life: 4000});
      });

    await this.graficoAtividadeService.graficoDataConcluido(usuarioLogado.empresa.codigo, '2022-01-01', '2022-12-31')
      .then(response => {
        this.setState({graficoAtividadesConcluido: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Graficos Atividades', detail:`${this.state.detail}`, life: 4000});
      });

    let nomeMeses = [];
    for(let i = 0; i < this.state.meses.length; i++) {
      nomeMeses.push(this.state.meses[i].mes);
    }

    let dataLimite = [];
    for(let i = 0; i < this.state.graficoAtividadesDataLimite.length; i++) {
      dataLimite.push(this.state.graficoAtividadesDataLimite[i].total);
    }

    let concluidos = [];
    for(let i = 0; i < this.state.graficoAtividadesConcluido.length; i++) {
      concluidos.push(this.state.graficoAtividadesConcluido[i].total);
    }

    await this.setState({graficoAtividadesDataLImiteConcluidoData: {
      labels: nomeMeses,
      datasets: [
        {

          label: 'Data Limite',
          backgroundColor: '#FF0000',
          data: dataLimite

        },
        {

          label: 'Concluídas',
          backgroundColor: '#008000',
          data: concluidos

        }
      ]
    }})
  }

  atividadesCriadas = async (dataInicial, dataFinal) => {
    const usuarioLogado = this.context.usuarioAutenticado
    await this.graficoAtividadeService.graficoTotal(usuarioLogado.empresa.codigo, dataInicial, dataFinal)
      .then(response => {
        this.setState({graficoAtividades: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Graficos Atividades', detail:`${this.state.detail}`, life: 4000});
      })

    let nomeMeses = [];
    for(let i = 0; i < this.state.meses.length; i++) {
      nomeMeses.push(this.state.meses[i].mes);
    }

    let atividades = [];
    for(let i = 0; i < this.state.graficoAtividades.length; i++) {
      atividades.push(this.state.graficoAtividades[i].total);
    }

    await this.setState({graficoAtividadesData: {
      labels: nomeMeses,
      datasets: [
        {

          label: 'Atividades',
          backgroundColor: '#008000',
          data: atividades
        }
      ]
    }})
  }

  graficosAtividadesSituacao = async (dataInicial, dataFinal) => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.graficoAtividadeService.graficoAtividadesSituacao(usuarioLogado.empresa.codigo, dataInicial, dataFinal)
      .then(response => {
        this.setState({graficoSituacaoEmpresa: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Graficos Atividades', detail:`${this.state.detail}`, life: 4000});
      });
    
    let valores = [];
    for(let i = 0; i < this.state.graficoSituacaoEmpresa.length; i++) {
      valores.push(this.state.graficoSituacaoEmpresa[i].atrasados);
      valores.push(this.state.graficoSituacaoEmpresa[i].concluidosAtrasados);
      valores.push(this.state.graficoSituacaoEmpresa[i].concluidosPrazo);
    }  

    await this.setState({graficoSituacaoEmpresaData: {
      labels: ['Atrasados', 'Concl. Atraso', 'Concl. Prazo'],
      datasets: [
        {
          data: [this.state.graficoSituacaoEmpresa[0].atrasados, 
                 this.state.graficoSituacaoEmpresa[0].concluidosAtrasados,
                 this.state.graficoSituacaoEmpresa[0].concluidosPrazo],
          backgroundColor: [
            "#FF6384",
            "#36A2EB",
            "#FFCE56"
          ],
          hoverBackgroundColor: [
            "#FF6384",
            "#36A2EB",
            "#FFCE56"
          ]
        }
      ]
    }})
  }

  graficoAtividadeGrupo = async (dataInicial, dataFinal) => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.graficoAtividadeService.graficoAtividadeGrupo(usuarioLogado.empresa.codigo, dataInicial, dataFinal)
      .then(response => {
        this.setState({graficoAtividadeGrupo: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Graficos Atividades', detail:`${this.state.detail}`, life: 4000});
      });

      //Grupos
      let grupos = [];
      for(let i = 0; i < this.state.graficoAtividadeGrupo.length; i++) {
        grupos.push(this.state.graficoAtividadeGrupo[i].grupo);
      }
      //Cores
      let cores = [];
      for(let i = 0; i < this.state.graficoAtividadeGrupo.length; i++) {
        cores.push(this.state.graficoAtividadeGrupo[i].cor);
      }

      //Total
      let valores = [];
      for(let i = 0; i < this.state.graficoAtividadeGrupo.length; i++) {
        valores.push(this.state.graficoAtividadeGrupo[i].total);
      }

      await this.setState({graficoAtividadeGrupoPie: {
        labels: grupos,
        datasets: [
          {
            data: valores,
            backgroundColor: cores,
          }
        ]
      }});
  }

  graficoAtividadeFase = async (dataInicial, dataFinal) => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.graficoAtividadeService.graficoAtividadeFase(usuarioLogado.empresa.codigo,
      dataInicial, dataFinal)
      .then(response => {
        this.setState({graficoAtividadeFases: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Graficos Atividades', detail:'Erro ao gerar Gráfico de Atividades por Fase', life: 4000});
      });

      //Fases
      let fases = [];
      for(let i = 0; i < this.state.graficoAtividadeFases.length; i++) {
        fases.push(this.state.graficoAtividadeFases[i].fase);
      }
      //Cores
      let cores = [];
      for(let i = 0; i < this.state.graficoAtividadeFases.length; i++) {
        cores.push(this.state.graficoAtividadeFases[i].cor);
      }

      //Total
      let valores = [];
      for(let i = 0; i < this.state.graficoAtividadeFases.length; i++) {
        valores.push(this.state.graficoAtividadeFases[i].total);
      }

      await this.setState({graficoAtividadeFasesPie: {
        labels: fases,
        datasets: [
          {
            data: valores,
            label: 'Fases',
            backgroundColor: cores,
          }
        ]
      }});
  }

  pad2 = (n) => {
    return (n < 10 ? '0' : '') + n;
  }

  consultarGraficos = async () => {
    this.setState({openSpinner: true});
    await this.listarMeses();
  
    //Data Inicial
    var dataFormatadaInicial = '';
    if(this.state.dataInicialGeral != '') {
      var date = this.state.dataInicialGeral;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      dataFormatadaInicial =  year+"-"+month+"-"+day;
    }

    //Data final
    var dataFormatadaFinal = '';
    if(this.state.dataFinalGeral != '') {
      var date = this.state.dataFinalGeral;
      var month = this.pad2(date.getMonth()+1);//months (0-11) kleiton
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      dataFormatadaFinal =  year+"-"+month+"-"+day;
    }  

    await this.atividadesCriadas(dataFormatadaInicial,dataFormatadaFinal);
    await this.ativdadesStatus(dataFormatadaInicial,dataFormatadaFinal);
    await this.graficoAtividadeFase(dataFormatadaInicial,dataFormatadaFinal);
    await this.graficoAtividadeGrupo(dataFormatadaInicial, dataFormatadaFinal);
    await this.graficosAtividadesSituacao(dataFormatadaInicial, dataFormatadaFinal);
    this.setState({openSpinner: false});
  }

  async componentDidMount() {
    this.setState({openSpinner: true});
    await this.listarMeses();

    var data = new Date();
    var dia = String(data.getDate()). padStart(2, '0');
    var mes = String(data.getMonth() + 1). padStart(2, '0');
    var ano = data. getFullYear();
    var dataInicial = ano + '-' + '01' + '-01';
    var dataFinal = ano + '-' + '12' + '-' + '31';

    var dataInicial2 = new Date(dataInicial);
    dataInicial2.setDate(dataInicial2.getDate()+1)

    var dataFinal2 = new Date(dataFinal);
    dataFinal2.setDate(dataFinal2.getDate()+1)

    this.setState({dataInicialGeral: dataInicial2});
    this.setState({dataFinalGeral: dataFinal2});
    this.setState({dataInicialUsuario: dataInicial2});
    this.setState({dataFinalUsuario: dataFinal2});

    await this.atividadesCriadas(dataInicial,dataFinal);
    await this.ativdadesStatus(dataInicial,dataFinal);
    await this.graficoAtividadeFase(dataInicial, dataFinal);
    await this.graficoAtividadeGrupo(dataInicial, dataFinal);
    await this.graficosAtividadesSituacao(dataInicial, dataFinal);
    this.setState({openSpinner: false});
  }

  getLightTheme() {
    let basicOptions = {
        maintainAspectRatio: false,
        aspectRatio: .8,
        plugins: {
            legend: {
                labels: {
                    color: '#495057'
                }
            }
        },
        scales: {
            x: {
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            },
            y: {
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            }
        }
    };

    let horizontalOptions = {
        indexAxis: 'y',
        maintainAspectRatio: false,
        aspectRatio: .8,
        plugins: {
            legend: {
                labels: {
                    color: '#495057'
                }
            }
        },
        scales: {
            x: {
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            },
            y: {
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            }
        }
    };

    let stackedOptions = {
        maintainAspectRatio: false,
        aspectRatio: .8,
        plugins: {
            tooltips: {
                mode: 'index',
                intersect: false
            },
            legend: {
                labels: {
                    color: '#495057'
                }
            }
        },
        scales: {
            x: {
                stacked: true,
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            },
            y: {
                stacked: true,
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            }
        }
    };

    let multiAxisOptions = {
        maintainAspectRatio: false,
        aspectRatio: .8,
        plugins: {
            legend: {
                labels: {
                    color: '#495057'
                }
            },
            tooltips: {
                mode: 'index',
                intersect: true
            }
        },
        scales: {
            x: {
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            },
            y: {
                type: 'linear',
                display: true,
                position: 'left',
                ticks: {
                    min: 0,
                    max: 100,
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            },
            y1: {
                type: 'linear',
                display: true,
                position: 'right',
                grid: {
                    drawOnChartArea: false,
                    color: '#ebedef'
                },
                ticks: {
                    min: 0,
                    max: 100,
                    color: '#495057'
                }
            }
        }
    };

    return {
        basicOptions,
        horizontalOptions,
        stackedOptions,
        multiAxisOptions
    }
  }

  render() {
    const { basicOptions, horizontalOptions, multiAxisOptions, stackedOptions } = this.options;
    return(
      <>
        <NavBar/>
        <Toast ref={(el) => this.toast = el} />
        <div className="content-wrapper">
          <section className="content-header">
            <div className="container-fluid">
            <div className="row">
                <div className="col-md-12">
                  <div className="card card-primary card-outline">
                    <div className="card-header">
                      <h3 className="card-title">
                        <i className="fas fa-hand-holding-usd"></i>
                          <span> Gráficos Atividades</span>
                      </h3>  
                    </div>
                    <div className="card-body">

                      <div className="card">
                          <div className="row">
                            <div className="col-sm-12">
                              <div className="formGroup">
                                <div style={{padding: '5px'}}>
                                  &nbsp;
                                  &nbsp;
                                  &nbsp;
                                  &nbsp;
                                  <span style={{color: '#cccccc', fontSize: '18px', fontWeight: 'bold', fontStyle: 'italic'}}>
                                    Período
                                  </span>
                                  &nbsp;
                                  &nbsp;
                                  <span style={{textAlign: 'center'}}>
                                    <Calendar id="mask" 
                                              value={this.state.dataInicialGeral} 
                                              onChange={(e) => this.setState({ dataInicialGeral: e.value })} 
                                              locale="es"
                                              style={{height: '32px', width: '145px'}} 
                                              dateFormat="dd/mm/yy"
                                              mask="99/99/9999"/>
                                      &nbsp;
                                    <Calendar id="mask" 
                                              value={this.state.dataFinalGeral} 
                                              onChange={(e) => this.setState({ dataFinalGeral: e.value })} 
                                              locale="es"
                                              style={{height: '32px', width: '145px'}} 
                                              dateFormat="dd/mm/yy"
                                              mask="99/99/9999"/>
                                    
                                    &nbsp;
                                    &nbsp;
                                    <Button style={{height: '32px'}} type="button" className="p-button-info p-button-text p-button-sm" 
                                            onClick={this.consultarGraficos}>
                                        <i className="pi pi-filter"></i> &nbsp;Consultar</Button>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <Backdrop
                          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                          open={this.state.openSpinner}>
                          <CircularProgress color="primary" style={{width: '130px', height: '130px'}}/>
                        </Backdrop>

                      <div className="row">
                        <div className="col-sm-12">
                          <div className="formGroup">
                            <div className="card flex justify-content-center">
                                <h5>Atividades Criadas</h5>
                                <Chart type="bar" data={this.state.graficoAtividadesData} options={basicOptions} />
                            </div>  
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="formGroup">
                            <div className="card flex justify-content-center">
                                <h5>Fases da Atividade</h5>
                                <Chart type="bar" data={this.state.graficoAtividadeFasesPie} options={horizontalOptions} />
                            </div>  
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-4">
                          <div className="formGroup">
                            <div className="card flex justify-content-center" style={{alignItems: 'center'}}>
                                <h5>
                                  Situação
                                </h5>
                                <Chart type="doughnut" data={this.state.graficoSituacaoEmpresaData} />
                            </div>  
                          </div>
                        </div>
                        <div className="col-sm-4">
                          <div className="formGroup">
                            <div className="card flex justify-content-center" style={{alignItems: 'center'}}>
                                <h5>Por Status</h5>
                                <Chart type="pie" data={this.state.graficoStatusData} />
                            </div>  
                          </div>
                        </div>
                        <div className="col-sm-4">
                          <div className="formGroup">
                            <div className="card flex justify-content-center" style={{alignItems: 'center'}}>
                                <h5>Por Grupo de Trabalho</h5>
                                <Chart type="pie" data={this.state.graficoAtividadeGrupoPie} />
                            </div>  
                          </div>
                        </div>
                      </div>
                      <div className="card">
                        <div className="row">
                          <div className="col-sm-12">
                            <div className="formGroup">
                              <div style={{padding: '5px'}}>
                                <span style={{fontSize: '18px', color: '#36A2EB', fontWeight: 'bold', fontFamily: 'Times New Roman Bold Italic'}}>
                                  Usuários
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </>
    )
  }
}

GraficoAtividades.contextType = AuthContext;
export default withRouter (GraficoAtividades)
